import { cn } from "@/lib/utils";

interface SectionDividerProps {
  /** Uppercase eyebrow label rendered between the gold rules. */
  eyebrow: string;
  className?: string;
}

/**
 * Refined editorial section divider — a centered gold hairline with
 * an uppercase eyebrow label. Reused across homepage section headers
 * for a consistent, measured rhythm.
 */
export function SectionDivider({ eyebrow, className }: SectionDividerProps) {
  return (
    <div
      className={cn("flex items-center justify-center gap-3 mb-6", className)}
    >
      <div className="w-8 h-px bg-accent/50" />
      <span className="text-accent text-[11px] font-semibold tracking-[0.3em] uppercase">
        {eyebrow}
      </span>
      <div className="w-8 h-px bg-accent/50" />
    </div>
  );
}
